import { useState } from "react";
import { getRangeAsLabels, IDateRange } from "../Components/DateRangeSelector";
import {
  IAllFilterData,
  ILogRowData,
  checkItems,
  checkModels,
  downloadJsonAsCsv,
  getCsvFilename,
  getFilterData,
} from "../utils";
import { FilterDropdown, IFilterState } from "../FilterSelect";
import { TimelineChart } from "../Components/TimelineChart";
import { analyticsChartModels } from "../config";

const SingleDeviceTimeline = ({
  logData,
  numDays,
  dateRange,
  appId,
}: // model,
{
  // model: keyof typeof analyticsChartModels;
  logData: ILogRowData[];
  numDays: number;
  dateRange: IDateRange;
  appId: string;
}) => {
  const filterData = getFilterData(logData);

  // Timeline data
  const [timelineFilters, setTimelineFilters] = useState<IFilterState>({});
  const isFiltering = Object.keys(timelineFilters).length > 0;

  const timelineData = isFiltering
    ? logData.filter((row) => {
        return (
          (!timelineFilters.action || timelineFilters.action === row.action) &&
          (!timelineFilters.button || timelineFilters.button === row.button) &&
          (!timelineFilters.path || timelineFilters.path === row.path) &&
          (!timelineFilters.info || timelineFilters.info === row.info) &&
          (!timelineFilters.models ||
            checkModels(row, timelineFilters.models)) &&
          (!timelineFilters.items || checkItems(row, timelineFilters.items))
        );
      })
    : logData;

  const updateFilter = (
    key: keyof IAllFilterData,
    newFilter: string | undefined
  ) => {
    const newFilters = { ...timelineFilters, [key]: newFilter };
    if (!newFilters[key]) delete newFilters[key];
    setTimelineFilters(newFilters);
  };

  return (
    <div>
      <div className="flex gap-2 mb-4">
        <div>{`Timeline of interactions during ${getRangeAsLabels(
          dateRange
        )}`}</div>
        <div>-</div>
        <div className="text-xs place-self-center text-gray-500 hover:text-gray-700">
          <button
            className="underline"
            onClick={() =>
              downloadJsonAsCsv(
                logData,
                getCsvFilename(dateRange, appId, "ActivityByTime")
              )
            }
          >
            Download data as CSV
          </button>
        </div>
      </div>
      <div className="flex gap-4">
        {filterData.models && (
          <div className="space-y-2">
            <div className="text-sm">Type</div>
            <FilterDropdown
              options={filterData.models}
              onChange={(e) => updateFilter("models", e)}
              value={timelineFilters.models}
              defaultLabel="All Models"
            />
          </div>
        )}
        {filterData.items && (
          <div className="space-y-2">
            <div className="text-sm">Items</div>
            <FilterDropdown
              options={filterData.items}
              onChange={(e) => updateFilter("items", e)}
              value={timelineFilters.items}
              defaultLabel="All Items"
            />
          </div>
        )}
      </div>
      <TimelineChart
        displayData={timelineData}
        days={numDays}
        dateRange={dateRange}
      />
    </div>
  );
};

export { SingleDeviceTimeline };
